import { Box, IconProps, Text, useBreakpointValue } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { useMenu } from "../../../hooks/useMenu";

type IProps = {
  item: IMenuItem<IconProps>;
  type: INavItemType;
};

function NavItem({ item, type }: IProps) {
  const navigate = useNavigate();
  const isMobile = useBreakpointValue({ base: true, md: false });

  const { rootUrl, isActive } = useMenu();

  const getFontSize = (name: IMenuItem<IconProps>["name"]) => {
    switch (name) {
      case "Learn":
        return "1.6rem";
      case "Courses":
        return "1.6rem";
      case "Leagues":
        return "1.3rem";
      case "Profile":
        return "1.6rem";
      case "Search":
      case "Premium":
        return "1.6rem";
      default:
        return "1.8rem";
    }
  };

  let active = isActive(item.path);

  if (isMobile) {
    return (
      <Box
        display={"flex"}
        cursor={"pointer"}
        flexDirection={type === "side" ? "row" : "column"}
        justifyContent={type === "side" ? "start" : "center"}
        width={"5rem"}
        alignItems={"center"}
        h={type === "side" ? "3.2rem" : "3.6rem"}
        px={type === "side" ? "1.6rem" : ".5rem"}
        minW={type === "side" ? "100%" : { base: "none", md: "6.25rem" }}
        gap={type === "side" ? "1rem" : ".2rem"}
        onClick={() => navigate(`/${rootUrl}/${item.path}`)}
      >
        {item.icon({
          color: active ? "white" : "whiteAlpha.500",
          fontSize: getFontSize(item.name),
        })}
        <Text
          fontWeight={active ? "700" : "inherit"}
          color={active ? "white" : "whiteAlpha.800"}
          textAlign={"center"}
          fontSize={"x-small"}
        >
          {item.name}
        </Text>
      </Box>
    );
  }

  return (
    <Box
      className="backone"
      cursor={"pointer"}
      borderRadius={"1rem"}
      minW={type === "side" ? "100%" : { base: "none", md: "6.25rem" }}
      _hover={{
        "&": {
          background: "neutral.950",
          outline: "2px solid",
          outlineOffset: "-2px",
          outlineColor: "neutral.900",
        },
        "& .frontone": {
          borderColor: "neutral.900",
          transform: "translateY(-4px)",
          background: !active ? "background" : "neutral.950",
        },
      }}
      _active={{
        "& .frontone": {
          borderColor: "neutral.900",
          transform: "translateY(-1px)",
          background: "background",
        },
      }}
      sx={{
        ...(active
          ? {
              "&": {
                background: "neutral.950",
                outline: "2px solid",
                outlineOffset: "-2px",
                outlineColor: "neutral.900",
              },
              "& .frontone": {
                borderColor: "neutral.900",
                transform: "translateY(-4px)",
                background: "neutral.950",
              },
            }
          : {}),
      }}
      onClick={() => navigate(`/${rootUrl}/${item.path}`)}
    >
      <Box
        className="frontone"
        display={"flex"}
        flexDirection={type === "side" ? "row" : "column"}
        justifyContent={type === "side" ? "start" : "center"}
        alignItems={"center"}
        h={type === "side" ? "3.2rem" : "3.6rem"}
        gap={type === "side" ? "1rem" : ".2rem"}
        px={type === "side" ? "1.6rem" : ".5rem"}
        transform={"translateY(-4px)"}
        willChange={"transform"}
        border={"2px solid transparent"}
        borderRadius={"1rem"}
      >
        {item.icon({
          // color: active ? "blackAlpha.900" : "whiteAlpha.500",
          fontSize: getFontSize(item.name),
        })}
        <Text
          fontWeight={"500"}
          // color={active ? "black" : "whiteAlpha.800"}
          textAlign={"center"}
        >
          {item.name}
        </Text>
      </Box>
    </Box>
  );
}

export default NavItem;
